import { CartDocument } from '@generated'
import { devtoolsExchange } from '@urql/devtools'
import { cacheExchange } from '@urql/exchange-graphcache'
import { Client, createClient, dedupExchange, Exchange, fetchExchange, ssrExchange } from 'urql'
let client: null | Client

export const createUrqlClient = (language: string, reset = false) => {
  let url = process.env.NEXT_PUBLIC_API_URL
    ? `${process.env.NEXT_PUBLIC_API_URL}/graphql`
    : 'http://localhost:4000/api/graphql'

  const exchanges = [
    dedupExchange,
    cacheExchange({
      keys: {
        ArticleAttribute: null,
        ArticlesPayload: null,
        FilterPayload: null,
        ArticleFilterAttributeValue: null,
        ArticleAttributeFilter: null,
        BrandCollectionFilter: null,
        BrandTypeFilter: null,
        ArticleTypeFilters: null,
        ArticleTypeFilter: null,
        CartMeta: null,
        Transactions: null,
        OrderByIdAndEmailPayload: data => data.order['id'],
        OrderByOrderNrAndEmailPayload: data => data.order['id']
      },
      optimistic: {
        removeItemFromCart: (variables, cache) => {
          const query = cache.readQuery({
            query: CartDocument,
            variables: { reference: variables.reference }
          })
          if (query) {
            // @ts-ignore
            const items = query.cart.items.filter(item => item.id !== variables.cartItemId)
            // @ts-ignore
            return { ...query.cart, items }
          }
        },
        updateCartItemSize: (variables, cache) => {
          const query = cache.readQuery({
            query: CartDocument,
            variables: { reference: variables.reference }
          })
          if (query) {
            // @ts-ignore
            const items = query.cart.items.map(item => {
              return item.id === variables.cartItemId
                ? {
                    ...item,
                    // @tes-ignore
                    size: variables.size
                  }
                : item
            })
            // @ts-ignore
            return { ...query.cart, items }
          }
        }
      }
    }),
    ssrExchange({
      isClient: typeof window !== 'undefined',
      initialState: undefined
    }),
    fetchExchange,
    process.env.NODE_ENV === 'development' && devtoolsExchange
  ].filter(t => t)

  // On each server request create a new client
  if (!client || reset) {
    client = createClient({
      url,
      exchanges: exchanges as Exchange[],
      fetch,
      fetchOptions: () => {
        const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null
        let headers = {
          Language: language
        }
        if (token) {
          headers['authorization'] = `Bearer ${token}`
        }
        return {
          headers
        }
      }
    })
  }

  return client
}
